module.exports = __webpack_public_path__ + "static/img/dkcg.07bb6c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dkcg.png
// module id = /RZq
// module chunks = 167